export const BUDGETS_RESET_STATE = 'BUDGETS_RESET_STATE';
export const BUDGETS_CURRENT_ITEM = 'BUDGETS_CURRENT_ITEM';

export const BUDGETS_REQUEST_LOADING = 'BUDGETS_REQUEST_LOADING';
export const BUDGETS_REQUEST_SUCCESS = 'BUDGETS_REQUEST_SUCCESS';
export const BUDGETS_REQUEST_FAILED = 'BUDGETS_REQUEST_FAILED';

export const BUDGETS_CURRENT_ACTION = 'BUDGETS_CURRENT_ACTION';
export const BUDGETS_RESET_ACTION = 'BUDGETS_RESET_ACTION';